import { AliasType } from "../../PostFlow";

export function aliasReplacement(state?: string, alias?: AliasType) {
  if (state == null) {
    return state;
  }

  let newState = state;
  if (alias) {
    for (const entry of Object.entries(alias)) {
      newState = newState.replaceAll(`{{${entry[0]}}}`, `${entry[1]}`);
    }
  }
  return newState;
}